export default {
    serverUrl: 'https://stage.zipe.zenoo.com/api/v1',
    serverFolder: 'demo',
    configFilename: 'config.stage.json'
}
